module.exports = __webpack_public_path__ + "img/E2 UP2.5fd0016f.png";